import { Spinner } from '@efdigital/ll-xceed-v2/components/application/spinner.gts';
import type { TOC } from '@ember/component/template-only';

interface CoachingCoacheeCohortQuizLoadingSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  <div class="container my-3">
    <Spinner />
  </div>
</template> satisfies TOC<CoachingCoacheeCohortQuizLoadingSignature>;
